import { LanguageSchema } from "@/assets/lang";

const tr: LanguageSchema = {
  "title": "Ahtapot",
  "button": {
    "cancel": "İptal",
    "ok": "TAMAM.",
    "discardChanges": "Değişiklikleri reddetme",
    "search": "Gözat",
    "confirm": "Onaylayın",
    "choose": "Seçiniz",
    "forward": "Sonraki",
    "back": "Geri",
    "reset": "Geri",
    "apply": "Başvurmak",
    "login": "Giriş yap",
    "logout": "Oturumu kapat",
    "send": "Gönder",
    "backToStart": "Başlangıca geri dön",
    "backToLogin": "Girişe geri dön",
    "no": "Hayır",
    "yes": "Evet",
    "toPayment": "Ödeme için",
    "finishOrder": "Sipariş verin",
    "thank": "Teşekkür ederim.",
    "sendInvite": "Davetiye gönder",
    "resend": "Yeniden Gönder",
    "startNow": "Şimdi başlayın",
    "skip": "Atla",
    "register": "Şimdi kaydolun",
    "registerNoCode": "Kod olmadan kayıt olun",
    "save": "Kaydet",
    "saveChanges": "Değişiklikleri uygula",
    "delete": "{target} sil",
    "addCart": "Listeyi alışveriş sepetine ekle",
    "orderNow": "Şimdi sipariş verin",
    "add": "Eklemek için",
    "changePassword": "Şifre değiştirme",
    "changeLogin": "Giriş bilgilerini değiştirme",
    "changeEmail": "E-posta değiştir",
    "edit": "Düzenle",
    "share": "Paylaş",
    "delivererNotFound": "Tedarikçi bulunamadı mı?",
    "joinLocation": "Ekibe katılın",
    "createLocation": "Konum oluştur",
    "editSupplier": "Tedarikçi @.lower:button.edit",
    "create": "Oluştur",
    "deleteSupplier": "Tedarikçiyi sil",
    "forwardApp": "Uygulamaya gidin",
    "endIntro": "Giriş bölümünü bitirin",
    "upload": "Yükle",
    "showMore": "daha fazla göster",
    "hide": "Gizle",
    "deleteAll": "Tümünü sil",
    "settings": "Ayarlar",
    "manualSort": "Manuel sıralamayı düzenleme",
    "switchOldVersion": "Eski sürüme",
    "goToAppVersion": "Tarayıcıda Octopus'u kullanma",
    "updateList": "Listeye ekle",
    "updateCart": "Sepete ekle",
    "openCameraScanner": "Kamera tarayıcısını açın",
    "orderOverview": "Siparişe genel bakış için",
    "deleteSupplierCart": "Alışveriş sepetini sil",
    "resetAmount": "Ürün miktarlarını sıfırlama",
    "requestAiCall": "AI çağrısı talep edin",
    "filter": {
      "all": "Her şey",
      "promotion": "Eylemler",
      "productSuggestion": "İlhamlar"
    }
  },
  "input": {
    "text": "Metin",
    "password": "Şifre | Şifreler",
    "email": "E-posta",
    "number": "Sayı",
    "url": "Bağlantı",
    "tel": "Telefon",
    "search": "Arama",
    "date": "Tarih",
    "orderDate": "Sipariş tarihi",
    "datetime": "Tarih",
    "datetime-local": "Saat yerel saat",
    "month": "Ay",
    "week": "Hafta",
    "time": "Zaman",
    "range": "Ölçek",
    "color": "Renk"
  },
  "table": {
    "empty": "Tablo öğeleri seçmiyor"
  },
  "label": {
    "confirm": "onaylayın",
    "pwConfirm": "@:input.password @:label.confirm",
    "newReminder": "Yeni sipariş alarmı ekle",
    "selectPlaceholder": "Lütfen seçiniz",
    "orderHint": "Tedarikçinin notu",
    "selectTitle": "Seçiniz",
    "date": "@:input.date",
    "time": "Zaman",
    "dateTime": "@:label.date ve @:label.time",
    "sum": "Toplam",
    "orderDetails": "Fatura detayları",
    "promoCode": "Kupon kodu",
    "orderNumber": "Sipariş numarası",
    "octopusId": "Ahtapot Kimliği",
    "orderMessage": "Sipariş mesajı",
    "description": "Açıklama",
    "sort": "Sırala",
    "priceRange": "Fiyat aralığı",
    "login": "Lütfen giriş yapın",
    "user": "Kullanıcı",
    "newEmail": "Yeni e-posta",
    "oldPassword": "Eski @:input.password",
    "password": "@:input.password",
    "pwForget": "@:input.password forgotten",
    "contactData": "İletişim bilgileri",
    "name": "İsim",
    "list": "Liste",
    "type": "Tip",
    "zip": "POSTA KODU",
    "city": "Şehir",
    "street": "Adres",
    "streetNumber": "Ev numarası",
    "phone": "Telefon",
    "fax": "Faks",
    "streetName": "Sokak adı",
    "postalCode": "@:label.zip",
    "deliverer": "@:object.deliverer",
    "customerNumber": "Müşteri numarası/satın alma yeri numarası",
    "quickstart": "Hızlı başlangıç kodu",
    "email": "@:input.email",
    "firstName": "İlk isim",
    "lastName": "İsim",
    "dark": "Karanlık",
    "light": "Işık",
    "standard": "Sistem ayarı",
    "amount": "Miktar",
    "multipleAmount": "miktarı {target} değerinin katı olmalıdır",
    "maxAmount": "Maksimum {target} öğe",
    "standardList": "Standart liste",
    "language": "Dil",
    "aiCallLanguage": "Çağrı dili",
    "oldMessages": "Daha eski haberler",
    "notification": {
      "allow": "Mesajlara izin ver"
    },
    "permission": {
      "order": "@:object.order",
      "promotion": "@:object.promotion",
      "message": "@:object.message",
      "news": "Haberler",
      "reminder": "Sipariş hatırlatma",
      "productPromotion": "Ürün önerileri",
      "sub": {
        "newOrder": "Yeni siparişler",
        "updateStatus": "Sipariş güncellemesi",
        "added": "Yeni promosyon",
        "ending": "Promosyon",
        "general": "Genel"
      },
      "mode": {
        "push": "Push mesajı",
        "email": "E-posta bildirimi",
        "popup": "Popup"
      }
    },
    "teamRole": {
      "admin": "Yönetici",
      "user": "Ekip üyesi Pro",
      "device": "Ekip üyesi tabanı",
      "OWNER": "Sahibi"
    },
    "teamRoleShort": {
      "admin": "Yönetici",
      "user": "Profesyonel",
      "device": "Üs",
      "OWNER": "Sahibi"
    },
    "support": {
      "general": "Ahtapot Desteği",
      "gastro": "Takım Müşteri Hizmetleri Gastro",
      "technical": "Teknik Müşteri Hizmetleri Ekibi",
      "technicalLead": "Teknik Lider",
      "distribution": "İmza yetkilisi, pazarlama, satış",
      "service": "Müşteri Hizmetleri Ekibi"
    },
    "loading": {
      "location": "Yükleniyor @:object.location"
    },
    "onAccount": "Fatura",
    "onAccountOrCash": "Fatura veya nakit",
    "ON_ACCOUNT": "@:label.onAccount",
    "UNSPECIFIED": "belirtilmemiş",
    "CASH": "@:label.cash",
    "cash": "Bar",
    "bar": "Bar / pub",
    "office": "Ofis",
    "coffeeShop": "Kafe / Bistro",
    "caterer": "Yemek şirketi / kantin / kulüpler",
    "club": "Kulüp / diskotek",
    "EVENT": "Etkinlik",
    "DEALER": "Tüccar",
    "takeAway": "Snack bar / Kiosk / Paket Servis",
    "canteen": "Kantin",
    "restaurant": "Restoran",
    "hotel": "Otel",
    "spaetshop": "Benzin istasyonu / gece mağazası",
    "getraenkehaendler": "İçecek perakendecisi",
    "getraenkeabholmarkt": "İçecek toplama pazarı",
    "STAR_GASTRONOMY": "Yıldız gastronomi",
    "SYSTEM_GASTRONOMY": "Sistem ikramı",
    "spaetShop": "Geç dükkan",
    "impress": "Künye",
    "termsOfUse": "Kullanım Koşulları",
    "agreeAGB1": "Kabul ediyorum",
    "agreeAGB2": "Gizlilik Politikası",
    "agreeAGB3": "için",
    "category": "Kategori",
    "noCategory": "Kategori olmadan",
    "editTags": "Kendi kategorilerinizi oluşturun",
    "selectDeliverer": "Select @:object.deliverer",
    "threeChars": "Arama sonuçlarını almak için en az üç karakter girin",
    "offlineMode": "Çevrimdışı mod",
    "disable": "devre dışı bırak",
    "enable": "aktive et",
    "at": "at",
    "atTime": "at",
    "and": "ve",
    "customerNo": "Müşteri numarası",
    "current": "Güncel",
    "tags": "Filtre kategorileri",
    "ownCategories": "Kendi kategorileriniz",
    "supplierCategories": "Tedarikçi kategorileri",
    "noFilter": "Filtre yok",
    "quantity": "Miktar",
    "quantityBiggerZero": "Miktar ile",
    "or": "veya",
    "delivererType": {
      "online": "Çevrimiçi",
      "offline": "Çevrimdışı"
    },
    "deleted": "Silinmiş",
    "resetAmount": "Siparişten sonra ürün miktarını sıfırlama",
    "compatibilityMode": "Uyumluluk modu",
    "timeIssueDelivery": "Belirttiğiniz teslimat tarihi geçmişte kaldı. Lütfen daha sonraki bir tarih seçin.",
    "timeIssuePickup": "Girdiğiniz tahsilat zamanı geçmişte kaldı. Lütfen daha sonraki bir tarih seçin.",
    "wait": "Lütfen bekleyin",
    "day": "Etiket",
    "month": "Ay",
    "all": "Tümü",
    "articleNo": "Ürün no.",
    "targetStock": "Hedef miktar",
    "targetStockShort": "Hedef",
    "resetProductQuantity": "Kaydırıcıyı etkinleştirdiğinizde, siparişinizin başarılı bir şekilde iletilmesinden sonra ürün miktarı sıfırlanır. Etkinleştirmezseniz, ürün miktarı listenizin bir sonraki işlenmesi için önceden doldurulmuş olarak kalır.",
    "offlineMode1": "Çevrimdışı mod size listenizi senkronize etme ve internet bağlantısı olmadan yönetme imkanı verir.",
    "offlineMode2": "Çevrimdışı moddan çıktığınızda, tüm değişiklikler sunucu ile senkronize edilir.",
    "darkMode": "Karanlık mod",
    "compatibilityText": {
      "activate": "Listenizdeki ürün miktarlarını uygulamada düzenlemek ancak siparişi web portalı üzerinden vermek istiyorsanız bu modu etkinleştirin.",
      "webPortal": "Bu mod etkinleştirildiği sürece, liste miktarı web portalı ile senkronize edilir ve bu listeyi uygulama üzerinden sipariş etmek mümkün değildir.",
      "deactivate": "Uygulama üzerinden sipariş vermek istiyorsanız bu modu devre dışı bırakın."
    },
    "newProductSuggestion": "Yeni ürün teklifi",
    "files": "Dosyalar",
    "issue": "Problem",
    "place": "Konum",
    "expectation": "Beklenti",
    "steps": "Adımlar",
    "availability": "Kullanılabilirlik",
    "availableFrom": "Şu adresten ulaşılabilir",
    "deletedLocations": "Silinen yerler",
    "reducedListDesign": "Azaltılmış liste tasarımı",
    "reducedListDesignDescription": "Küçültülmüş liste tasarımı, listenizin görünümünü değiştirir. Ürün resimleri gizlenir, ancak işlem için ek düğmeler görüntülenir.",
    "insert": "Ekle",
    "camera": "Kamera tarayıcısı",
    "scanner": "Tarayıcı",
    "picture": {
      "takePicture": "Bir fotoğraf çekin",
      "selectPicture": "Resim seçiniz",
      "editPicture": "Resmi düzenle",
      "removePicture": "Resmi kaldır"
    },
    "uncategorized": "Uncategorized",
    "orderDataLoading": "Sipariş verileri yüklenir.",
    "screenshot": "Ekran görüntüsü",
    "uploadImage": "Resim yükle",
    "aiCallbackPhone": "Geri arama için telefon numarasını kaydetme",
    "chat": {
      "roomsEmpty": "Henüz hiçbir sohbet yok",
      "roomEmpty": "Seçili bir sohbet yok",
      "newMessages": "Yeni mesajlar",
      "messageDeleted": "Mesaj silindi",
      "messagesEmpty": "İlk mesajını yaz",
      "conversationStarted": "Sohbet başlatıldı:",
      "typeMessage": "Mesaj yaz…",
      "search": "Ara"
    }
  },
  "error": {
    "addReminder": "Sipariş alarmı bir listeye atanamadı",
    "noMatch": "{target} eşleşmiyor",
    "notFound": "{target} bulunamadı. | {target} bulunamadı.",
    "invalid": "{target} doğru değil. | {target} doğru değil.",
    "empty": "{target} boş. | {target} boş.",
    "noAuth": "{target}'in izni yok. | {target}'in izni yok.",
    "noAdmin": "Yönetici izni bulunamadı.",
    "addCart": "Ürün alışveriş sepetine eklenemedi. | ürün alışveriş sepetine eklenemedi.",
    "addPromoPackage": "Promosyon paketi alışveriş sepetine eklenmedi veya yalnızca kısmen eklendi.",
    "addList": "Ürün listeye eklenemedi. | Ürünler listeye eklenemedi.",
    "create": "{target} oluşturulamadı. | {target} oluşturulamadı.",
    "order": "Sipariş işleme alınamadı.",
    "save": "{target} kaydedilemedi.",
    "delete": "{target} silinemedi.",
    "deleteUser": "Kullanıcı silinemedi.",
    "resendMail": "E-posta yeniden gönderilemedi.",
    "sendLink": "Bağlantı gönderilemedi.",
    "removeProduct": "Ürün alışveriş sepetinden kaldırılamadı. | Ürün alışveriş sepetinden çıkarılamadı.",
    "registerFalse": "Kayıt başarısız oldu.",
    "loginFalse": "Giriş başarısız oldu.",
    "locationFalse": "Konum oluşturma başarısız oldu.",
    "orderFinish": "Sipariş oluşturulamadı.",
    "send": "{target} gönderilemedi.",
    "loadSupplier": "Tedarikçi yüklenemedi | Tedarikçiler yüklenemedi.",
    "loadLists": "Listeler yüklenemedi.",
    "load": "{target} yüklenemedi. | {target} yüklenemedi.",
    "sendTicket": "Geri bildirim gönderilemedi.",
    "scanBarcode": "Taranan barkod geçersiz.",
    "promotionLimitReached": "Maks. Eylem miktarına ulaşıldı",
    "aiCall": "@:error.returnType.Unknown",
    "ajv": {
      "required": "Zorunlu alanlar doldurulmamış",
      "format": "Girdi doğru değildi: Girdi {formatInfo} biçiminde olmalıdır.",
      "formatInfo": {
        "date": "Tarih",
        "time": "Zaman",
        "email": "E-posta",
        "date-time": "Tarih & amp; Saat"
      },
      "oneOf": "Girdi olası değerlerden hiçbiriyle eşleşmiyor",
      "minimum": "Girdi minimum {min} değerinin altına düşüyor",
      "maximum": "Girdi {max} maksimum değerini aşıyor",
      "enum": "Girdi olası değerlerden birini içermiyor"
    },
    "returnType": {
      "Unknown": "Bir hata oluştu",
      "BadRequest": "Talep yanlış veri içeriyor",
      "NotFound": "İstek bir öğe bulamadı.",
      "Unauthorized": "Eksik yetkilendirme",
      "Forbidden": "Talebe izin verilmiyor",
      "NotImplemented": "Talep uygulanmadı",
      "InvalidLogin": "Geçersiz giriş",
      "InvalidSession": "Geçersiz oturum",
      "InvalidPassword": "Geçersiz şifre",
      "UserNotFound": "Kullanıcı bulunamadı",
      "UserAlreadyExists": "Kullanıcı zaten mevcut",
      "UserEmailAlreadyExists": "Bu e-postaya sahip bir kullanıcı zaten mevcut",
      "LocationNotFound": "Konum bulunamadı",
      "CartItemNotFound": "Ürün bulunamadı",
      "ItemAlreadyInCart": "Ürün zaten alışveriş sepetinde, alışveriş sepetinde seçiminizi düzenleyin",
      "ListAlreadyInCart": "Liste zaten alışveriş sepetinde, seçiminizi alışveriş sepetinde düzenleyin. Liste yalnızca alışveriş sepetinde sipariş verildikten sonra düzenlenebilir.",
      "ListCantBeDeleted": "Liste silinemez.",
      "ListEmpty": "Liste boş. En az bir ürünün miktarının 0'dan fazla olup olmadığını kontrol edin.",
      "SupplierNotFound": "Tedarikçi bulunamadı",
      "SupplierItemNotFound": "Tedarikçi ürünü bulunamadı",
      "OrderNotFound": "Sipariş bulunamadı",
      "ListNotFound": "Liste bulunamadı",
      "ListItemNotFound": "Ürün listesi bulunamadı",
      "ItemAlreadyInList": "Ürün zaten listede, listedeki seçiminizi düzenleyin",
      "ItemNotFromListSupplier": "Ürün bu listedeki tedarikçilerden değil",
      "NotificationNotFound": "Bildirim bulunamadı",
      "TagNotFound": "Kategori bulunamadı",
      "TagAlreadyExists": "Kategori zaten mevcut",
      "UserNotInTeam": "Bu kullanıcı ekipte değil",
      "TokenInvalid": "Girilen kod geçersiz",
      "ReminderNotFound": "Sipariş hatırlatıcısı bulunamadı",
      "OwnerCantBeEdited": "Sahibinin düzenleme yetkisi yoktur",
      "PromoCodeInvalid": "Kupon kodu geçerli değil",
      "PromoCodeInvalidAlreadyExists": "Kupon kodu zaten kullanılmış",
      "QuickStartCodeInvalid": "Hızlı başlangıç kodu geçersiz",
      "SupplierAlreadyExists": "Tedarikçi zaten mevcut",
      "SupplierCustomerInvalid": "Konum tedarikçisi geçersiz",
      "LocationAlreadyExists": "Konum zaten mevcut",
      "JavaApiInternalServerError": "Bir hata oluştu",
      "NewsNotFound": "Mesaj bulunamadı",
      "OrderMessageTooLong": "Sipariş mesajı maksimum uzunluğu aşıyor",
      "EmailInvalid": "E-posta geçersiz",
      "TokenInvalidAlreadyUsed": "Girilen kod zaten kullanılmış",
      "SupplierBlocked": "Tedarikçi engellendi",
      "PromotionExpired": "Promosyon ürünlerinin son kullanma tarihi"
    },
    "scannedProductNotAvailable": "Taranan ürün tedarikçinizin kataloğunda mevcut değildir, bu nedenle tarayıcı listesine eklenemez.",
    "scannerNotAvailable": "Cihazınıza bağlı bir tarayıcı yok. Lütfen bir tarayıcıya bağlanın veya mevcut bağlantınızı kontrol edin",
    "chat": {
      "loadMessages": "Mesajlar yüklenemedi",
      "sendMessage": "Mesaj gönderilemedi",
      "openRoom": "Sohbet açılmadı",
      "allowedMimeTypes": "Yalnızca JPG, PNG veya PDF dosyaları kabul edilir",
      "maxSize": "Dosya çok büyük (maks. {target} MB)",
      "maxFilesPerMessage": "Mesaj başına en fazla {target} dosya"
    }
  },
  "error.": "Bir hata oluştu",
  "target": {
    "username": "Kullanıcı Adı",
    "user": "Kullanıcı",
    "userAndPw": "@:target.username ve @:input.password",
    "setting": "Ayar | Ayarlar",
    "profile": "Profil",
    "location": "Konum",
    "order": {
      "paypal": "PayPal"
    },
    "product": "Ürün | Ürünler",
    "request": "İstek",
    "list": "Liste",
    "required": "Zorunlu alan",
    "field": "Alan | Alanlar",
    "deliverer": "Tedarikçi | Tedarikçiler",
    "tag": "Kategori | Kategoriler",
    "password": "Şifre",
    "permission": "Yetkilendirme | İzinler"
  },
  "messages": {
    "orderFrom": "Sipariş vermek için",
    "mobileWeb": "Octopus Order web sürümünü bir mobil cihazdan açmaya çalıştığınızı fark ettik. Daha iyi bir kullanıcı deneyimi için mobil cihazlarda uygulama mağazanızdan mobil uygulamayı indirmenizi ve web sürümü yerine bunu kullanmanızı öneririz.",
    "mobileWeb2": "Aşağıdaki bağlantılar sizi Octopus Order mobil uygulamasına götürecektir:",
    "setting": {
      "location": "Konumunuzu düzenleyin",
      "profile": "Kullanıcı profilinizi düzenleyin",
      "delivererAssign": "Konumunuza bir tedarikçi atayın",
      "delivererSelect": "Tedarikçi seçin",
      "inputCustomerNr": "Müşteri numarasını girin",
      "changeLocation": "Konum değiştir",
      "welcome1": "Merhaba {name}",
      "welcome2": "Burada şunları seçebilirsiniz",
      "welcome3": "hangi temsili tercih edersiniz"
    },
    "emptyCart": "Üzgünüz, alışveriş sepetiniz boş.",
    "emptySuggestion": "Üzgünüz, şu anda sizin için herhangi bir ürün önerimiz yok.",
    "card": {
      "forwardPoints": "object.pointSystem sayfamıza yönlendirilmek için buraya tıklayın",
      "points": "Ahtapot puanları",
      "shop": "Ahtapot dükkanına",
      "currentPromotion": "Güncel eylemler",
      "createLocationExplanation": "Bir yer bar, restoran, otel, ofis veya benzeri bir işletme olabilir.",
      "productSuggestion": "Ürün haberleri ve öneriler"
    },
    "noPromotion": "Üzgünüz, şu anda sizin için herhangi bir promosyonumuz yok.",
    "promotion": {
      "order": "Adresinden sipariş edilebilir",
      "octopus": "Ahtapot promosyonları",
      "deliverer": "Tedarikçilerinizden gelen promosyonlar",
      "articles": "Bu makalelerin şu anda özel bir fiyatı var"
    },
    "home": {
      "createLocation": "Yeni @:messages.location.create",
      "welcome1": "Merhaba {name}",
      "welcome2": "hangi konumu istersiniz?",
      "image1": "Karıştırıldı, dinlendi, sipariş edildi!",
      "image2": "Güvenli, dijital, sipariş!",
      "image3": "Basit, hızlı, teslim!"
    },
    "dashboard": {
      "catalog": {
        "availableProduct": "Mevcut tüm makaleler",
        "delivererCatalog": "Tedarikçinin ürün yelpazesi",
        "createProduct": "Ürün ekle",
        "createdCustomProduct": "Ürün listeye eklenmiştir.",
        "noReducedSupplier": "Şu anda tedarikçilerinizden hiçbiri anlaşma sunmuyor."
      },
      "home": {
        "orders": "Son siparişleriniz",
        "favouriteList": "Son sipariş listeleriniz",
        "news": "Ahtapot Haberleri"
      },
      "list": {
        "allLists": "Bu konumun tüm listeleri",
        "createList": "Yeni @:titleRoute.addList",
        "noSupplier": "Konumunuza henüz bir tedarikçi eklemediniz. Lütfen ayarlar üzerinden bir tedarikçi ekleyin."
      },
      "message": {
        "available": "Haberler mevcut"
      },
      "setting": {
        "order": "Siparişlerinizle ilgili her şey bir bakışta",
        "team": "Ekibinize genel bakış ve yönetim",
        "deliverer": "Burada tedarikçilerinizi görebilirsiniz",
        "notification": "Bildirimlerinizi buradan yönetin",
        "display": "Koyu veya Açık Mod arasında seçim yapın",
        "statistic": "Değerlendirmelerinizi buradan görüntüleyebilirsiniz",
        "imprint": "Bilgi ve yasal",
        "support": "İletişim Ahtapot Sipariş",
        "orderNotificationTimer": "Sipariş alarmınızı ayarlayın",
        "intro": "Uygulamanın tüm özelliklerini keşfedin"
      }
    },
    "location": {
      "thank": "@:button.thank",
      "sendMsg": "Mesaj gönder",
      "create": "Konum ekle",
      "requestSent": "Tedarikçi {deliverer} ile ilgili talebiniz inceleniyor. Önümüzdeki günlerde bir temsilci sizinle iletişime geçecektir.",
      "assignDeliverer": "Konumunuza bir tedarikçi atayın",
      "welcome1": "Merhaba {name}",
      "intro": "4 kısa adımda profilinizi birlikte tamamlıyoruz"
    },
    "noOrders": "Henüz herhangi bir sipariş vermediniz.",
    "noOrdersFilter": "Bu zaman diliminde herhangi bir sipariş vermediniz.",
    "noLists": "Henüz herhangi bir liste oluşturmadınız.",
    "noNotifications": "Henüz herhangi bir bildirim almadınız.",
    "noNews": "Üzgünüz, şu anda Octopus ile ilgili herhangi bir haber bulunmamaktadır.",
    "order": {
      "deliveryType": "Teslimat yöntemini seçin",
      "deliveryTime": "Teslimat gününü seçin",
      "pickupTime": "Teslim alma saatini seçin",
      "pickup": "Almak",
      "delivery": "Teslimat",
      "overview": "Siparişe genel bakış",
      "choosePayment": "Ödeme yöntemini seçin",
      "redirectPayment": "Bir sonraki adımda {target} adresine yönlendirileceksiniz.",
      "rememberPayment": "Gelecekteki siparişler için ödeme yöntemini kullanın.",
      "voucher": "Kupon | Kuponlar",
      "redeemVoucher": "@:messages.order.voucher redeem",
      "voucherCode": "Kupon kodunu girin",
      "currentOrders": "Benim emirlerim",
      "orderProducts": "Siparişiniz @:object.article",
      "otherProducts": "Sık sipariş edilen diğer makaleler",
      "sent": "Siparişiniz {target}'e başarıyla iletilmiştir.",
      "locationIssue": "Teslim alma konumu eksik. Lütfen bir teslim alma konumu girin."
    },
    "deliverer": {
      "allDeliverers": "Tümü @:object.deliverer from {location}",
      "addDeliverer": "Bir @:object.deliverer ekleyin",
      "noEmail": "Sipariş vermeden önce lütfen teslimatçıya bir e-posta adresi ekleyin"
    },
    "team": {
      "invite": {
        "welcome1": "@:messages.home.welcome1",
        "welcome2": "Diğer çalışanları veya ortakları uygulamaya davet edin...",
        "copy": "Ya da sadece kodu kopyalayın ve paylaşın:",
        "messenger": "Doğrudan seçtiğiniz mesajlaşma programı üzerinden davet edin:",
        "mail": "E-posta adresi ile",
        "joinTeam": "Ekibimize katılın",
        "joinTeam2": "Octopus Order Uygulamasında {location} konumuna davet edildiniz!\n\nBu bağlantı ile doğrudan ekibinize katılabilirsiniz.\n\n{inviteLink}\n\nBu bağlantı çalışmazsa, kod ile uygulamada ekibinize katılabilirsiniz\n\n{link}\n\nyeni ekibinize katılmak için.\n\nAndroid için: {appLinkAndroid}\n\nIOS için: {appLinkIOS}",
        "shareHint": "Güvenlik nedeniyle, oluşturulan/gönderilen kod yalnızca temel kullanıcıları davet edebilir. Seçilen haklara sahip bir davetiye için lütfen e-posta davetiyesini kullanın."
      },
      "management": {
        "members": "{location}'dan ekip üyeleri",
        "inviteMember": "Ekip üyelerini davet edin",
        "addDevice": "Cihaz ekleme",
        "permissionExplanation": "Rollerimizin haklarına genel bakış:"
      }
    },
    "missingPermission": "Eksik izin: {permission}",
    "missingCartOrderPermission": "Uygulamadaki izinleriniz yeterli değil. Siparişi tamamlamak için lütfen konumunuzun sahibiyle iletişime geçin.",
    "permission": {
      "all": "Tüm izinler",
      "locationOrderHistoryRead": "Sipariş geçmişini okuyun",
      "locationListRead": "Listeleri görüntüle",
      "locationListItemRead": "Ürün listesini görüntüle",
      "locationListItemCreate": "Liste ürünleri oluşturma",
      "locationListItemUpdate": "Liste ürünlerini düzenleme",
      "locationListItemDelete": "Liste ürünlerini silme",
      "locationListCreate": "Liste oluşturma",
      "locationListUpdate": "Listeleri düzenle",
      "locationListDelete": "Listeleri sil",
      "locationCartRead": "Alışveriş sepetini görüntüle",
      "locationCartAdd": "Alışveriş sepetini doldurun",
      "locationCartUpdate": "Alışveriş sepeti ürünlerini düzenleme",
      "locationCartDelete": "Alışveriş sepeti ürünlerini silme",
      "locationOrderCreate": "Sipariş oluştur",
      "locationOrderRequest": "Sipariş talebini gerçekleştir",
      "locationRead": "Konumu görüntüle",
      "locationCreate": "Konum oluştur",
      "locationUpdate": "Konumu düzenle",
      "locationDelete": "Konum silme",
      "locationTeamRead": "Ekibi görüntüle",
      "locationTeamMemberAdd": "Ekip üyesi ekle",
      "locationTeamMemberDelete": "Ekip üyesini sil",
      "locationTeamMemberRoleUpdate": "Ekip üyesi rollerini düzenleme",
      "locationSupplierRead": "Tedarikçileri görüntüle",
      "locationSupplierCreate": "Tedarikçiler ekleyin",
      "meRead": "Kendi kullanıcı verilerini okuma",
      "meUpdate": "Kendi kullanıcı verilerini düzenleme",
      "meDelete": "Kendi kullanıcınızı silin",
      "locationListReminderCreate": "Sipariş alarmı oluşturun",
      "locationListReminderDelete": "Sipariş alarmını sil",
      "locationListReminderRead": "Sipariş alarmını görüntüle",
      "locationListReminderUpdate": "Sipariş alarmını düzenle",
      "locationContactSupplier": "İletişim tedarikçisi",
      "locationChatRead": "Sohbeti oku",
      "locationChatCreate": "Mesaj gönder"
    },
    "noListEntries": "Bu listede şu anda hiçbir öğe yok",
    "noSearchResults": "Filtreniz için hiçbir makale bulunamadı",
    "noEntries": "Mevcut ürün yok",
    "noMail": "Posta alınmadı",
    "login": {
      "emailSent": "Az önce size bir e-posta gönderdik",
      "setPassword": "Bağlantı üzerinden yeni bir şifre belirleyebilirsiniz",
      "resetPassword": "E-posta adresinizi girin ve yeni bir şifre alın"
    },
    "start": {
      "notNew": "Zaten müşterinizim",
      "new": "Buraya ilk kez geliyorum"
    },
    "cart": {
      "amount": "{amount} Öğe konumları",
      "selectionFrom": "Seçim {deliverer}'da",
      "fromList": "Listelerinizden",
      "noList": "Liste olmadan",
      "lastOrder": "Son siparişinizden",
      "amountItems": "{amount} Tek makale",
      "upgradeToPromotion": "Neredeyse geldik! Sadece {amount} Parçaları {shortTitle}'e kadar Eylem 🏷️ → şimdi sipariş ver",
      "convertToPromotion": "Eylem güvence altına alındı 🏷️ → şimdi etkinleştirin"
    },
    "register": {
      "intro": "Profilinizi oluşturmak için bazı bilgilere ihtiyacımız var",
      "thank": "Teşekkürler {name}",
      "emailSent": "@:messages.login.emailSent",
      "validate": "Lütfen hesabınızı bağlantı üzerinden onaylayın",
      "validateEmail": "@:{'messages.register.validate'} sipariş vermeden önce e-posta adresinize gönderilir",
      "noCode": "Davetiye kodum yok",
      "code": "Bir davetiye kodu aldım",
      "skipEmail": "Maalesef girdiğiniz e-posta adresini bulamadık. Lütfen e-posta adresinizi tekrar onaylayın."
    },
    "didYouMean": "Acaba {target}'i mi arıyorsunuz?",
    "didYouCheck": "Önceki görünümde tüm tedarikçileri aradınız mı?",
    "agbRequired": "Gizlilik politikasını kabul etmeniz gerekmektedir.",
    "list": {
      "repeatEach1": "Hatırlatma",
      "repeatEach2": "Tümü",
      "noTags": "Filtre kategorileri mevcut değil. Liste ürünlerinize kategori ekleyin.",
      "overrideCartList": "Liste zaten alışveriş sepetinde. Alışveriş sepetinizin üzerine yazmak istiyor musunuz?",
      "overrideProductList": "Bu ürün zaten alışveriş sepetinizde. Alışveriş sepetinizin üzerine yazmak ister misiniz?",
      "noReminder": "Bu liste için henüz herhangi bir sipariş alarmı oluşturulmamıştır.",
      "amountReset": "Ürün miktarları sıfırlandı.",
      "resetCheck": "Bu listedeki tüm miktarları 0'a sıfırlamak istediğinizden emin misiniz?"
    },
    "pressEnter": "Eklemek için klavyede onaylayın",
    "changedEmail": "Az önce size yeni adresiniz için bir e-posta gönderdik. Değişikliği uygulamak için lütfen gönderilen bağlantıya tıklayın.",
    "updateLoading": "Güncelleme yükleniyor",
    "intro": {
      "home": {
        "msg1": "Konumunuza genel bakışa ve alışveriş sepetinize dönmek için başlığa tıklayın.",
        "title1": "Konumlarınıza ve alışveriş sepetine ulaşın",
        "msg2": "En son siparişlerinize ve sık sipariş edilen listelere doğrudan kontrol paneli üzerinden erişebilirsiniz.",
        "title2": "Faaliyetlerinize genel bakış",
        "msg3": "Tek bir tıklama ile hedefinize ulaşmak için menü çubuğunu kullanın.",
        "title3": "Navigasyona her yerden erişilebilir"
      },
      "list": {
        "title1": "Sipariş burada başlıyor",
        "msg1": "Listelerinize ve kataloğa başlık üzerinden erişebilirsiniz. Burada tedarikçilerinizin makalelerini arayabilirsiniz.",
        "title2": "Tedarikçileriniz",
        "msg2": "Burada tedarikçilerinizin sipariş listelerini görüntüleyebilir ve düzenleyebilir veya kendiniz yeni listeler oluşturabilirsiniz.",
        "title3": "Sıralama ve silme",
        "msg3": "Ürün resmine dokunarak tek veya birden fazla ürünü seçin, sürükleyip bırakarak taşıyın veya çöp kutusu simgesine dokunarak silin.",
        "title4": "Listeyi kolayca özelleştirin",
        "msg4": "Ürünün miktarı artı ve eksi tuşlarıyla değiştirilebilir. Ürünü listeden kaldırmak için sağa kaydırın.",
        "title5": "Öğeleri hızlıca bulun",
        "msg5": "Katalogda tedarikçilerinizin ürünlerini tek tek görüntüleyebilir, arayabilir ve kategoriye göre filtreleyebilirsiniz."
      },
      "promotion": {
        "title1": "Promosyonlar ve öneriler",
        "msg1": "Burada tedarikçilerinizden veya Octopus Order'dan gelen güncel promosyonları, ürün önerilerini veya haberleri görebilirsiniz.",
        "title2": "Tedarikçilerinizden gelen promosyon teklifleri",
        "msg2": "Burada tedarikçilerinizden özel tekliflerin mevcut olduğu makaleleri görebilirsiniz.",
        "title3": "Güncel öneriler ve haberler",
        "msg3": "Ürün önerileri ile içecek sektöründeki son trendler hakkında bilgi edinebilirsiniz. Haberler bölümünde Octopus ile ilgili en son haberleri bulabilirsiniz."
      },
      "setting": {
        "msg1": "Burada tedarikçilerinizi ve konumlarınızı yönetebilir, ayarlar yapabilir, siparişleri görüntüleyebilir veya destekle iletişime geçebilirsiniz.",
        "title1": "Uygulama ayarları",
        "msg2": "Listenizin siparişini düzenli olarak hatırlatmak için buradan alarm kurabilirsiniz.",
        "title2": "Bir daha asla bir siparişi unutma",
        "msg3": "Burada ekibinizi yönetebilir ve diğer ekip üyelerini Octopus Order'a davet edebilirsiniz.",
        "title3": "Kendi ekibiniz",
        "msg4": "Burada tüm tedarikçilerinize genel bir bakışa sahip olursunuz ve onları düzenleyebilir veya kaldırabilir ve yeni tedarikçiler ekleyebilirsiniz.",
        "title4": "Tedarikçiye genel bakış"
      }
    },
    "ordering": "Sipariş gerçekleştiriliyor",
    "noConnection1": "Sunucuya bağlantı yok",
    "noConnection2": "Lütfen internet bağlantınızı kontrol edin",
    "switchLocation": "Bildirim başka bir konuma aittir. Konumu değiştirmek istiyor musunuz?",
    "containsExpiredPromotion": "Alışveriş sepetinizde süresi dolmuş bir promosyon ürünü var. Siparişinize devam etmek için lütfen kaldırın.",
    "addProductsViaScanner": "Tarayıcı aracılığıyla ürün ekleme",
    "scanDesiredProducts": "İstediğiniz ürünleri tarayın",
    "scanToAddMoreProducts": "Daha fazla ürün eklemek için tarayın",
    "updateScanItems": "Taradığınız öğeleri listenize eklemek ister misiniz? Listedeki öğe sayısının üzerine yazılacaktır.",
    "addScanItems": "Taradığınız ürünleri alışveriş sepetine eklemek ister misiniz?",
    "holidayDeliveryTitle": "Seçilen teslimat günü resmi tatildir!",
    "holidayDelivery": "Kesin teslimat tarihiniz için lütfen tedarikçinize danışın.",
    "longOrder": "Siparişinize yedi günden daha uzun bir süre var. Gerçekten {date}'da sipariş vermek istiyor musunuz?",
    "cartDataMissing": "Sipariş verileri hatalı",
    "newBinaryVersion": "Yeni bir sürüm mevcuttur ve önemli değişiklikler içermektedir. Lütfen sürümünüzü güncelleyin.",
    "deliveryDayWarningTitle": "Seçilen tarih normal bir teslimat günü değil!",
    "deliveryDayWarning": "Lütfen istisnai durumları tedarikçi ile önceden netleştirin.",
    "holidayPickupTitle": "Seçilen toplama günü resmi tatildir!",
    "holidayPickup": "Kesin toplama tarihiniz için lütfen tedarikçinize danışın.",
    "modal": {
      "updateLocationTypeTitle": "Sizin seçiminiz, sizin avantajınız",
      "updateLocationTypeDescription": "Catering işletmenizi seçtiğinizde, içeriği ve promosyonları sizin için özelleştiririz. Bu ayarı istediğiniz zaman değiştirebilirsiniz.",
      "updateLocationTypeHint": "Seçim yalnızca uygulama içinde kullanılır ve herhangi bir zamanda özelleştirilebilir."
    },
    "currentLocation": "Şu anda şu konumdasınız"
  },
  "object": {
    "order": "Sipariş | Siparişler",
    "article": "Ürün pozisyonları",
    "promotion": "Eylem | Eylemler",
    "location": "Konum",
    "cart": "Alışveriş sepeti",
    "list": "Liste | Listeler",
    "filter": "Filtre",
    "message": "Haberler | Haberler",
    "catalog": "Katalog",
    "notification": "Bildirim | Bildirimler",
    "notificationOption": "@:object.notification{'soptions'}",
    "setting": "Ayarlar",
    "intro": "Apptour",
    "home": "Ev",
    "dark": "Karanlık",
    "light": "Işık",
    "zip": "POSTA KODU",
    "city": "Şehir",
    "street": "Sokak",
    "lastname": "İsim",
    "firstname": "İlk isim",
    "address": "Adres",
    "zipCity": "nesne:zip, @nesne:şehir",
    "profile": "Profil",
    "pointSystem": "Puan sistemi",
    "amount": "Miktar",
    "price": "Birim fiyat",
    "total": "Toplam fiyat",
    "notAvailable": "Fiyat bilgisi mevcut değil",
    "sort": "Sırala",
    "alphabetic": "Alfabetik",
    "filterCategory": "@:object.filter{'category'}",
    "priceRange": "Fiyat aralığı",
    "team": "Takım",
    "deliverer": "Tedarikçi | Tedarikçiler",
    "display": "Görüntüleme seçenekleri",
    "statistic": "İstatistikler",
    "imprint": "Künye",
    "law": "Yasal",
    "support": "Ahtapot Sipariş Desteği",
    "filterOption": {
      "spirits": "Ruhlar",
      "nonAlcoholic": "Alkolsüz İçecekler",
      "beer": "Bira",
      "gastro": "Gastro ihtiyaçları",
      "wine": "Şarap",
      "food": "Yemek",
      "nonFood": "Gıda Dışı",
      "other": "Diğer"
    },
    "suggestion": "Ürün{öneri} | Ürün{öneri}",
    "news": "Haberler",
    "days": "Gün | Gün",
    "hours": "Saat | Saat",
    "minutes": "Dakika | Dakika",
    "validFor": "Valid for {value}",
    "validUntil": "Şu tarihe kadar geçerlidir",
    "expired": "Süresi doldu",
    "totalPosition": "Toplam pozisyon",
    "totalOrder": "Toplam sipariş değeri"
  },
  "enumT": {
    "pinned": "Sabitlendi",
    "new": "Yeni",
    "restocked": "Tekrar kullanılabilir",
    "reduced": "Teklif üzerine",
    "notInStock": "Teslimat süresi ile",
    "promotion": "Promosyon ürünleri",
    "issueType": {
      "bug": "Böcek",
      "feature": "Özellik"
    },
    "contactWay": {
      "none": "Lütfen iletişime geçmeyin",
      "email": "E-posta",
      "phone": "Telefon",
      "emailOrPhone": "E-posta veya telefon"
    },
    "sortDirection": {
      "asc": "Artan Alfabetik",
      "desc": "Azalan Alfabetik",
      "catFilter": "Kendi kategorisine göre",
      "catSupplier": "Tedarikçi kategorisine göre",
      "manually": "Manuel sıralama"
    },
    "weekday": {
      "mon": "Pazartesi",
      "tue": "Salı",
      "wed": "Çarşamba",
      "thu": "Perşembe",
      "fri": "Cuma",
      "sat": "Cumartesi",
      "sun": "Pazar"
    },
    "repeatCycle": {
      "once": "benzersiz",
      "week": "haftalık",
      "month": "aylık",
      "appendix": {
        "week": "hafta(lar)",
        "month": "ay(lar)"
      }
    },
    "month": {
      "january": "Ocak",
      "february": "Şubat",
      "march": "Mart",
      "april": "Nisan",
      "may": "Mayıs",
      "june": "Haziran",
      "july": "Temmuz",
      "august": "Ağustos",
      "september": "Eylül",
      "october": "Ekim",
      "november": "Kasım",
      "december": "Aralık"
    }
  },
  "modal": {
    "selection": "Seçenekler",
    "addList": "Listeye ekle",
    "addCart": "Alışveriş sepetine ekle",
    "openCatalog": "Katalogda aç"
  },
  "success": {
    "addReminder": "Sipariş alarm saati eklendi",
    "editReminder": "Sipariş alarmı kaydedildi",
    "deleteReminder": "Sipariş alarmı silindi",
    "addCart": "Ürün alışveriş sepetine eklendi. | ürün alişveri̇ş sepeti̇ne eklendi̇",
    "addPromoPackage": "Promosyon paketi alışveriş sepetine eklendi.",
    "addCartNumber": "{target} ürün konumlarından tek {target2} ürünler alışveriş sepetine eklendi",
    "addList": "Ürün listeye eklendi. | Ürünler listeye eklendi.",
    "order": "Liste sipariş edildi.",
    "save": "{target} başarıyla kaydedildi. | {target} başarıyla kaydedildi.",
    "resendMail": "E-posta yeniden gönderildi.",
    "copyLink": "Bağlantı kopyalandı",
    "sendLink": "Bağlantı gönderildi.",
    "removeProduct": "Ürün alışveriş sepetinden kaldırıldı. | Ürün alışveriş sepetinden kaldırıldı.",
    "orderFinish": "Sipariş oluşturuldu.",
    "delete": "{target} silindi.",
    "deleteUser": "Kullanıcı silindi",
    "deleteMulti": "{amount} {target} silindi.",
    "send": "{target} gönderildi.",
    "create": "{target} oluşturuldu.",
    "edit": "{target} başarıyla düzenlendi.",
    "add": "{target} eklendi.",
    "deleteTeam": "Kullanıcı ekip tarafından kaldırıldı.",
    "setRole": "Kullanıcı rolü başarıyla ayarlandı",
    "joinLocation": "Konum başarıyla eklendi",
    "sendInvite": "Davet e-postası gönderildi.",
    "sendTicket": "Geri bildiriminizi aldık. Çok teşekkür ederiz.",
    "aiCall": "Octobot birazdan sizi arayacak."
  },
  "success.": "Kampanya başarılı",
  "alert": {
    "delete": {
      "account": "Hesabını ve ilgili tüm konumları geri alınamaz şekilde silmek istiyor musun?",
      "reminder": "Bu sipariş alarmını gerçekten silmek istiyor musunuz?",
      "location": "Bu konumu gerçekten silmek istiyor musunuz?",
      "list": "Gerçekten \"{target}\" listesini silmek istiyor musunuz?",
      "noList": "Alışveriş sepetinizdeki tüm ürünleri kaldırmak ister misiniz?",
      "cartSupplier": "Alışveriş sepetinizi \"{target}\" adresinden boşaltmak mı istiyorsunuz?",
      "cartProduct": "Gerçekten \"{target}\" ürününü alışveriş sepetinden silmek istiyor musunuz?",
      "cartList": "Gerçekten \"{target}\" listesini ve ilgili tüm öğeleri alışveriş sepetinden kaldırmak istiyor musunuz?",
      "product": "Gerçekten \"{target}\" ürününü listeden silmek istiyor musunuz? | Seçili ürünleri listeden gerçekten silmek istiyor musunuz?",
      "supplier": "Tedarikçilerinizden {name}'i kaldırmak istiyor musunuz? Dikkat: Bir tedarikçiyi kaldırmak, bu tedarikçiye ait tüm listeleri de kaldırır.",
      "member": "Gerçekten {target}\"'ı ekipten çıkarmak istiyor musunuz?",
      "tag": "Kategorilerinizden \"{target}\" öğesini gerçekten kaldırmak istiyor musunuz?",
      "customSupplier": "Bu tedarikçiyi gerçekten silmek istiyor musunuz?",
      "scanProduct": "Taranan öğelerinizden \"{target}\" ürününü gerçekten kaldırmak istiyor musunuz?"
    },
    "delivererSuccess": "Tedarikçi başarıyla eklendi",
    "delivererError": "Hata",
    "delivererSuccessMessage": "Konumunuza {target} ekledik.",
    "delivererErrorMessage": "{target} konumunuza eklenemedi. Lütfen girdiğiniz verileri kontrol edin.",
    "selectList": "Bir liste seçin",
    "selectSupplier": "Bir tedarikçi seçin",
    "noList": "Bu tedarikçi için liste mevcut değil.",
    "noSupplier": "Bu ürün için tedarikçi mevcut değil",
    "discardFormTitle": "Dikkat!",
    "noInternet": "Tüm çevrimdışı veriler senkronize edilemeyebilir. Lütfen internet bağlantınızı kontrol edin.",
    "compatibilityMode": "Uyumluluk modunu etkinleştirdiniz. Bu aktifken, yalnızca web portalı üzerinden sipariş verebilirsiniz. Belirttiğiniz miktar artık alışveriş sepetinde. Uygulama üzerinden sipariş vermek istiyorsanız, liste ayarlarından bu modu devre dışı bırakın.",
    "discardForm": "Verileriniz kaydedilmeyecektir. Yine de sayfadan ayrılmak mı?",
    "syncing": "Listeler senkronize edilir",
    "logout": "Gerçekten kaydınızı sildirmek istiyor musunuz?",
    "upgradeToPromotion": "Promosyonu şimdi mi kullanıyorsunuz? Miktar otomatik olarak minimum miktara ayarlanır ({target})",
    "convertToPromotion1": "Eylemi uygulayın?",
    "convertToPromotion2": "{target1} Promosyon ürünü, {target2} normal",
    "orderAmountOverLimit": "Sınıra ulaşıldı: {isAmount} Alışveriş sepetinde promosyon ürünü. Maks. +{availableAmount} mümkün",
    "scannerNotActivated": "Tarayıcı işlevi şu anda tedarikçileriniz tarafından desteklenmiyor!",
    "scannerAvailableOnlyInApp": "Tarayıcı işlevi yalnızca uygulamada mevcuttur!",
    "addLastOrderToCart": "Son siparişindeki tüm ürünleri ve miktarlarını tekrar sepetine eklemek ister misin?"
  },
  "titleRoute": {
    "locationData": "Konum oluştur",
    "locationCreate": "@:titleRoute.locationData",
    "locationDeliverer": "Tedarikçi seçiniz",
    "locationAdd": "Konum ekle",
    "locationJoin": "Konum katılın",
    "addLocationDeliverer": "Tedarikçi ekle",
    "editLocationDeliverer": "Tedarikçiyi düzenle",
    "settingProfile": "Profil",
    "settingLocation": "Konumu düzenle",
    "settingOrder": "Sipariş | Siparişler",
    "settingOrderDetail": "Sipariş detayları",
    "settingTeam": "Takım",
    "settingTeamInvite": "Ekibi davet edin",
    "settingDeliverer": "Tedarikçiler",
    "settingDelivererSelect": "Tedarikçi seçin",
    "settingNotification": "Bildirimler",
    "settingDisplay": "Görüntüleme seçenekleri",
    "settingSupport": "Destek",
    "settingLegal": "Yasal",
    "cart": "Alışveriş sepeti",
    "orders": "Siparişler",
    "filter": "Filtre",
    "addList": "Liste oluştur",
    "editList": "Listeyi düzenle",
    "notificationDetails": "@:titleRoute.settingNotification",
    "orderNotificationTimer": "Sipariş alarmı",
    "changePassword": "Şifre değiştirme",
    "addProduct": "Ürün ekle",
    "editProduct": "Ürün düzenleme",
    "agb": "Gizlilik Politikası",
    "news": "Ahtapot Haberleri",
    "suggestion": "Ürün teklifi",
    "productDetails": "Ürün detayları",
    "promotionDetails": "Eylem ayrıntıları",
    "productPresentation": "@:titleRoute.productDetails",
    "promotion": "@:titleRoute.promotionDetails",
    "settingIntro": "Apptour",
    "feedback": "Geri bildirim oluşturun",
    "scanner": "Tarayıcı",
    "skipEmail": "E-posta doğrulama",
    "deleteLocations": "Silinen yerler",
    "aiCall": "Yapay zeka siparişi"
  },
  "placeholder": {
    "search": "Arama",
    "selectSize": "Boyut seçin",
    "selectVariant": "Varyant seçin",
    "location": {
      "name": "Bulunduğunuz yerin adı",
      "type": "Konum türü",
      "zip": "Posta kodu",
      "ownZip": "Kendi konumunuzun posta kodu",
      "city": "Şehir",
      "street": "Sokak",
      "streetNumber": "Hayır.",
      "phone": "Telefon numarası",
      "internationalPhone": "Uluslararası telefon numarası",
      "deliverer": "@:select object.deliverer",
      "customerNumber": "@:label.customerNumber girin"
    },
    "email": "E-posta",
    "newEmail": "Yeni e-posta",
    "oldPassword": "Eski @:input.password",
    "password": "@:input.password",
    "passwordRepeat": "@:input.password repeat",
    "sendMessageDeliverer": "deliverer} adresine mesaj gönderin ...",
    "inviteCode": "Davetiye kodunu girin",
    "firstName": "@:label.firstName",
    "lastName": "@:label.lastName",
    "name": "İsim",
    "phone": "@:placeholder.location.phone",
    "street": "Sokak",
    "zip": "POSTA KODU",
    "city": "Şehir",
    "alphabetic": "Alfabetik",
    "customerNumber": "Müşteri numarası",
    "customerNumberPlus": "Müşteri numarası/Satış noktası numarası",
    "quickstart": "Hızlı Başlangıç Kodu",
    "paymentMethod": "Ödeme yöntemi",
    "pickupMethod": "Konum",
    "deliveryDate": "Teslim tarihi",
    "emailOrPhone": "@:placeholder.email",
    "code": "Davetiye kodu",
    "packaging": "Paket boyutu",
    "searchOrAdd": "Kategori arayın veya ekleyin",
    "tagName": "Kategori adı",
    "pickupLocation": "İçeri al",
    "pickupDate": "Toplama süresi",
    "quantity": "Miktar",
    "eancode": "EAN Kodu",
    "customSupplierType": "Tedarikçi tipi",
    "issueType": "Geri bildirim türü",
    "title": "Başlık",
    "bug": {
      "issue": "Sorun nedir?",
      "place": "Sorun nerede meydana geliyor?",
      "expectation": "Mevcut davranış yerine hangi davranışı beklerdiniz?",
      "steps": "Hata oluşana kadar hangi adımlar atıldı? / Hata nasıl yeniden üretilebilir?"
    },
    "feature": {
      "expectation": "Hangi ek işlevi görmek istersiniz?",
      "place": "İstediğiniz işlevi nerede kaçırıyorsunuz?"
    },
    "select": "Seçiniz",
    "contactWay": "Soru ve güncellemeler için sizinle nasıl iletişime geçebiliriz?"
  },
  "option": {
    "industry": {
      "PRIVATE": "Özel",
      "GETRAENKEFACHGROSSHANDEL": "Toptan İçecekler",
      "LEBENSMITTEL_GROSSHANDEL": "Toptan gıda satışı",
      "HANDELSWAREN_ALLGEMEIN": "Genel ticari mallar",
      "SONSTIGE": "Diğer"
    },
    "customSupplierType": {
      "meat": "Et tedarikçisi",
      "vegetable": "Sebzeler",
      "drinks": "İçecekler",
      "hygiene": "Hijyen makaleleri",
      "other": "Diğer"
    }
  }
}

export default tr;